import React, { Dispatch, ReactElement, SetStateAction, useEffect, useRef, useState } from 'react';
import { TFunction, withTranslation } from "react-i18next";
import "./AdvancedRefund.scss";
import SubmitButton from '../controls/buttons/submitButton';
import { Modal } from "react-bootstrap";
import { AxiosResponse } from "axios";
import Page from '../containers/page';
import { ColumnDefinition, textColumnDefinition, numericColumnDefinition, actionColumnDefinition } from '../table/ColumnDefinition';
import CustomTable, { TableModeEnum } from '../table/CustomTable';
import FormFilter from '../containers/form-filter';
import SelectField from '../controls/fields/selectField';
import NumericField from '../controls/fields/numericField';
import DateField from '../controls/fields/dateField';
import { WebCache } from '../../services/WebCache';
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import { Link } from 'react-router-dom';
import TermsAndContions from '../layout/TermsAndCondition'
import RegulationCommerce from '../layout/RegulationCommerce'
import { AdvancedService } from '../../services/AdvancedService';
import {
    IAvailableSettlementsRequest,
    IAvailableSettlementsResponse,
    IcouponsSearchRequest,
    IcouponsSearchResponse,
    IliquidationsConfirmationRequest,
    IliquidationsConfirmationResponse,
    BalanceListDTO,
    IWS81PaymentLists,
    CommerceFiscalNumbersList,
    IEarlySettlementByAmountRequest,
    IEarlySettlementByAmountResponse
} from '../../models/IAdvancedData';
import { toast } from 'react-toastify';
import { ReactComponent as LogoSVG } from "itd-common/assets/icons/rollrequest.svg";
import { UtilService } from '../../services/UtilService';
import i18next from "i18next";
import NavigationTabLinksForCalendar from '../payments/NavigationTabLinksForCalendar';
import { DateHelper } from '../../helpers/DateHelper';
import { DateObject } from 'react-multi-date-picker';

interface IProps {
    t: TFunction
}
interface IFilters {
    comercios: string,
    issuingEntitysCode: string,
    payingEntitysCode: string,
    brandsCode: string,
    amount: string,
    cuits: string,
    dateRange: DateObject[]
};

type Option = {
    value: string,
    label: string
}

const T_PREFIX: string = 'pages.advanced.';
const ARGENTINA = "AR";
const ADVANCED_SEARCH_PATH = "/advanced/search";
const PAGE_SIZE = 20;
const PAGE_QUANTITY = 3;

const AdvancedRefund: React.FC<IProps> = ({ t }: IProps) => {
    const [fromDate, toDate] = DateHelper.buildDateRange();
    const [filters, setFilters] = useState<IFilters>({ comercios: "", issuingEntitysCode: WebCache.getAllPayerBanks(true)[0].value, payingEntitysCode: WebCache.getAllPayerBanks(true)[0].value, brandsCode: WebCache.getAllProducts(true)[0].value, amount: "", cuits: "", dateRange: [fromDate, toDate] });
    const [totalAmount, setTotalAmount] = useState<string>();
    const [showTermsAndConditionsModal, setShowTermsAndConditionsModal] = useState<boolean>(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [country, setCountry] = useState<string>(ARGENTINA);
    const [showRegulationCommerce, setShowRegulationCommerce] = useState(false)
    const [selectedRows, setSelectedRows] = useState<IWS81PaymentLists[]>([]);
    const [mainPage, setMainPage] = useState<number>(0)
    const [cuits, setCuits] = useState<Array<HTMLOptionElement>>(new OptionMapperHelper(t).translateOptionValues(WebCache.getAllMerchantDocuments(true, false)) as Array<HTMLOptionElement>);
    const [comercios, setComercios] = useState<Option[]>(new OptionMapperHelper(t).translateOptionValues(OptionMapperHelper.getAllMerchantNumbersOptions(WebCache.getAllMerchantDocuments(true, false)[0].label, true, false)) as Array<Option>);
    const [allComercios, setAllComercios] = useState<Option[]>(new OptionMapperHelper(t).translateOptionValues(OptionMapperHelper.getAllMerchantNumbersOptions(WebCache.getAllMerchantDocuments(true, false)[0].label, true, false)) as Array<Option>);
    const [allBrands, setAllBrands] = useState<Option[]>([] as Array<Option>);
    const [paymentEntityList, setPaymentEntityLists] = useState<Option[]>(new OptionMapperHelper(t).translateOptionValues(WebCache.getAllPayerBanks(true)) as Option[]);
    const [paymentEmiterList, setPaymentEmiterList] = useState<Option[]>(new OptionMapperHelper(t).translateOptionValues(WebCache.getAllPayerBanks(true)) as Option[]);
    const [balanceList, setBalanceList] = useState<BalanceListDTO[]>([]);
    const [paymentLists, setPaymentLists] = useState<IWS81PaymentLists[]>([]);
    const allPaymentListsRef = useRef<IWS81PaymentLists[]>([]);
    const [sumaryTotals, setSumaryTotals] = useState({ totalCouponsQuantity: 0, financialCost: "%", totalNetAmount: 0, totalPreviousCost: 0, totalAcreditedAmount: 0 });
    const [activeTab, setActiveTab] = useState<'porMonto' | 'porCupones'>('porMonto');
    const [showCouponsSidebar, setShowCouponsSidebar] = useState<boolean>(false);
    const [showConfirmationSidebar, setShowConfirmationSidebar] = useState<boolean>(false);
    const [showSuccessSidebar, setShowSuccessSidebar] = useState<boolean>(false);
    const [successMode, setSuccessMode] = useState<'monto' | 'cupones' | null>(null);
    const [isConfirmingAdvanced, setIsConfirmingAdvanced] = useState<boolean>(false);
    const [amountToAdvance, setAmountToAdvance] = useState<string>('');
    const [earlySettlementResult, setEarlySettlementResult] = useState<IEarlySettlementByAmountResponse | null>(null);
    const [isLoadingEarlySettlement, setIsLoadingEarlySettlement] = useState<boolean>(false);
    const [isCalculatingEarlySettlement, setIsCalculatingEarlySettlement] = useState<boolean>(false);
    const earlySettlementRequestRef = useRef<number>(0);

    const openTermsAndConditionsModal = () => {
        setCountry(ARGENTINA)
        setShowTermsAndConditionsModal(true);
    };

    const closeTermsAndConditionsModal = () => {
        setShowTermsAndConditionsModal(false);
    };

    const openRegulationCommerceModal = () => {
        setShowRegulationCommerce(true);
    }

    const closeRegulationCommerceModal = () => {
        setShowRegulationCommerce(false);
    }

    const clearFilters = () => {
        const [defaultFromDate, defaultToDate] = DateHelper.buildDateRange();
        setSelectedRows([]);
        setFilters({
            ...filters,
            comercios: "",
            issuingEntitysCode: "",
            payingEntitysCode: "",
            brandsCode: "",
            amount: "",
            cuits: "",
            dateRange: [defaultFromDate, defaultToDate]
        })
    }

    const handleBackToSchedule = () => {
        window.location.href = ADVANCED_SEARCH_PATH;
        window.location.reload();
    }

    const formatDateForWs81 = (dateObject?: DateObject): string => {
        if (!dateObject) {
            return "";
        }

        const date = DateHelper.dateObjectToDate(dateObject);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    const extractFiscalNumber = (merchantValue: string): string => {
        return merchantValue.split('-')[0]?.trim() ?? '';
    }

    const formatTnaPercent = (value: number): string => {
        return `${Intl.NumberFormat('es-UY', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value)}%`;
    }

    const buildEarlySettlementByAmountRequest = (amount: number): IEarlySettlementByAmountRequest => {
        return {
            fiscalNumbers: WebCache.getAllMerchantDocuments(false, false)?.map(item => item.value) ?? [],
            amount: amount * 100,
            brandsList: allBrands.map(x => x.value).filter(x => x.length > 0),
            paymentEntityList: paymentEntityList.map(x => x.value).filter(x => x.length > 0),
            emitterEntityList: paymentEmiterList.map(x => x.value).filter(x => x.length > 0),
            commerceFiscalNumbersList: allComercios.filter(x => x.value !== '').map(y => ({
                fiscalNumber: extractFiscalNumber(y.value),
                commerceNumber: y.label
            }))
        };
    }

    const calculateEarlySettlementByAmount = async ({
        amount,
        showErrorToast,
        showLoading,
        openConfirmation
    }: {
        amount: number,
        showErrorToast: boolean,
        showLoading: boolean,
        openConfirmation: boolean
    }) => {
        if (amount <= 0) {
            setEarlySettlementResult(null);
            return;
        }

        const requestId = ++earlySettlementRequestRef.current;

        if (showLoading) {
            setIsLoadingEarlySettlement(true);
        } else {
            setIsCalculatingEarlySettlement(true);
        }

        try {
            const request = buildEarlySettlementByAmountRequest(amount);
            const res: AxiosResponse<IEarlySettlementByAmountResponse> = await AdvancedService.earlySettlementByAmount(request);

            if (requestId !== earlySettlementRequestRef.current) {
                return;
            }

            if (res.data.success) {
                setEarlySettlementResult(res.data);
                if (openConfirmation) {
                    setShowConfirmationSidebar(true);
                }
            } else {
                setEarlySettlementResult(null);
                if (showErrorToast) {
                    toast.error(res.data.message || 'Error al calcular el anticipo');
                }
            }
        } catch (error) {
            if (requestId === earlySettlementRequestRef.current) {
                setEarlySettlementResult(null);
            }
            if (showErrorToast) {
                console.error('Error al calcular anticipo por monto:', error);
                toast.error('Error al calcular el anticipo por monto');
            }
        } finally {
            if (requestId === earlySettlementRequestRef.current) {
                if (showLoading) {
                    setIsLoadingEarlySettlement(false);
                } else {
                    setIsCalculatingEarlySettlement(false);
                }
            }
        }
    }

    useEffect(() => {
        if (filters.cuits && filters.cuits.length > 0) {
            setFilters({ ...filters, comercios: OptionMapperHelper.getAllMerchantNumbersOptions(filters.cuits, true, false)[0].key })
            setComercios(allComercios.filter(x => filters.cuits == "" ? true : x.value.indexOf(filters.cuits) == 0));
        }
    }, [filters.cuits]);

    useEffect(() => {
        setSelectedRows([]);
    }, [activeTab]);

    useEffect(() => {
        const totalCouponsQuantity = selectedRows.reduce((sum, row) => sum + (Number(row.couponsQuantity)), 0)
        const totalNetAmount = selectedRows.reduce((sum, row) => sum + (Number(row.netAmount)), 0)
        const totalPreviousCost = selectedRows.reduce((sum, row) => sum + (Number(row.previousCost)), 0)
        const totalAcreditedAmount = selectedRows.reduce((sum, row) => sum + (Number(row.acreditedAmount)), 0)

        setSumaryTotals({
            totalCouponsQuantity,
            financialCost: "%",
            totalAcreditedAmount,
            totalNetAmount,
            totalPreviousCost
        });
    }, [selectedRows])

    const availableSettlementsRequest = () => {
        const tranWebModel: IAvailableSettlementsRequest = {
            fiscalNumbers: WebCache.getAllMerchantDocuments(false, false)?.map(item => item.value), /* ["0033630659219", "0033711535719"], */
            Skip: 0,
            Take: 0,
        };
        return tranWebModel;
    }

    useEffect(() => {
        //Llamar al servicio que vamos a mostrar en el primer render de ADVANCED (WS80)
        const getInitSettlement = async () => {
            try {
                const res: AxiosResponse<IAvailableSettlementsResponse> = await AdvancedService.availableSettlements(availableSettlementsRequest());
                if (res.data) {
                    const paymentEntityOptions = [{ label: i18next.t("allFemale"), value: "" }].concat(res.data.paymentEntityLists.map((item) => ({
                        label: item.paymentEntityName,
                        value: item.paymentEntityName
                    })));
                    const paymentEmiterOptions = [{ label: i18next.t("allFemale"), value: "" }].concat(res.data.paymentEmiterLists.map((item) => ({
                        label: item.paymentEmiterName,
                        value: item.paymentEmiterName
                    })));
                    const brandsOptions = [{ label: i18next.t("allFemale"), value: "" }].concat(res.data.balanceLists.map((item) => ({
                        label: item.brandName,
                        value: item.brandName
                    })));
                    const merchantsOptions = [{ label: i18next.t("all"), value: "" }].concat(res.data.availableMerchants.map((item) => ({
                        label: item.value,
                        value: item.id
                    })));
                    setTotalAmount(res.data.totalAmount)
                    setBalanceList(res.data?.balanceLists || []);
                    setAllBrands(brandsOptions);
                    setPaymentEmiterList(paymentEmiterOptions)
                    setPaymentEntityLists(paymentEntityOptions)
                    setComercios(merchantsOptions.filter(x => filters.cuits == "" ? x : x.value.indexOf(filters.cuits) == 0));
                    setAllComercios(merchantsOptions);
                }
                ;
            } catch (error) {
                console.error("Error al mostrar cupones:", error);
                toast.error('Error al mostrar monto total disponible para adelantar');
            }
        };
        getInitSettlement();
    }, [])

    useEffect(() => {
        const availableAmount = Number(totalAmount || 0) / 100;
        const numericAmount = Number(amountToAdvance || 0);
        const isAmountValid = activeTab === 'porMonto' && amountToAdvance !== '' && numericAmount > 0 && numericAmount <= availableAmount;

        if (!isAmountValid) {
            setEarlySettlementResult(null);
            return;
        }

        const timer = setTimeout(() => {
            void calculateEarlySettlementByAmount({
                amount: numericAmount,
                showErrorToast: false,
                showLoading: false,
                openConfirmation: false
            });
        }, 450);

        return () => clearTimeout(timer);
    }, [amountToAdvance, activeTab, totalAmount, allBrands, paymentEntityList, paymentEmiterList, allComercios]);

    //#####################################################################  Render Methods ################################################################################## 

    /////////////////////////////////////////////////////////////Render anticipo por monto////////////////////////////////////////////////////////////////////////////////////////////
    const totalCoupon = (): ReactElement => {
        const availableAmount = Number(totalAmount || 0) / 100;
        const hasAvailableAmount = availableAmount > 0;
        const sidebarSelectedCoupons = earlySettlementResult?.selectedCoupons ?? [];
        const availableAmountFormatted = Intl.NumberFormat('es-UY', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(availableAmount);
        const isAmountExceeded = amountToAdvance !== '' && Number(amountToAdvance) > availableAmount;
        const formatUyuFromCents = (valueInCents: number) => Intl.NumberFormat('es-UY', { style: 'currency', currency: 'UYU' }).format(valueInCents / 100);
        const totalSidebarCoupons = sidebarSelectedCoupons.reduce((acc, c) => acc + Number(c.couponsQuantity), 0);
        const totalSidebarNetAmount = sidebarSelectedCoupons.reduce((acc, c) => acc + Number(c.netAmount), 0);

        const handleAmountToAdvanceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const sanitizedAmount = event.target.value.replace(/[^0-9]/g, '');
            setAmountToAdvance(sanitizedAmount);
        }

        const formattedAmountDisplay = amountToAdvance !== ''
            ? Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 }).format(Number(amountToAdvance))
            : '';
        const amountInputWidth = `${Math.max(formattedAmountDisplay.length, 1)}ch`;

        const handleEarlySettlement = async () => {
            if (isLoadingEarlySettlement || amountToAdvance === '' || Number(amountToAdvance) === 0 || isAmountExceeded) return;
            await calculateEarlySettlementByAmount({
                amount: Number(amountToAdvance),
                showErrorToast: true,
                showLoading: true,
                openConfirmation: true
            });
        };

        return (
                <>
                    <div className="advance-by-amount-outer">
                        <div className="advance-by-amount-inner">
                            <div className="advance-amount-input-title">¿Cuánto dinero necesitás anticipar?</div>
                            <div className="advance-amount-input-field">
                                <span className={`advance-amount-input-currency${isAmountExceeded ? ' advance-amount-input-currency--error' : ''}`}>$</span>
                                <input
                                    type="text"
                                    value={formattedAmountDisplay}
                                    onChange={handleAmountToAdvanceChange}
                                    inputMode="numeric"
                                    placeholder="0"
                                    className={`advance-amount-input-value${isAmountExceeded ? ' advance-amount-input-value--error' : ''}`}
                                    style={{ width: amountInputWidth }}
                                    aria-invalid={isAmountExceeded}
                                    aria-label="Monto a anticipar"
                                />
                            </div>
                            {isAmountExceeded ? (
                                <div className="advance-amount-exceeded-box">
                                    <span className="advance-amount-exceeded-text">
                                        Límite de anticipo excedido. Tu límite actual es ${availableAmountFormatted}
                                    </span>
                                </div>
                            ) : (
                                <div className="available-amount-box">
                                    Disponible: ${availableAmountFormatted}
                                </div>
                            )}
                            <p className="advance-amount-disclaimer">Este es el monto final que vas a recibir luego de descuentos. La acreditación del dinero es en 24hs hábiles.</p>
                            <div className="advance-summary-table">
                                <div className='advance-summary-table__subtable'>                            
                                    <div className="advance-summary-table__col">
                                        <span className="advance-summary-table__header">Neto solicitado</span>
                                        <span className="advance-summary-table__value">
                                            ${amountToAdvance !== '' ? Intl.NumberFormat('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(amountToAdvance)) : '0,00'}
                                        </span>
                                    </div>
                                    <div className="advance-summary-table__col">
                                        <span className="advance-summary-table__header">
                                            Bruto necesario
                                            <span className="advance-summary-table__tooltip" title="Bruto necesario: El importe puede resultar superior al necesario ya que se calcula del monto total de cada venta en condiciones de Anticipar">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                            </span>
                                        </span>
                                        <span className="advance-summary-table__value">
                                            {earlySettlementResult
                                                ? Intl.NumberFormat('es-UY', { style: 'currency', currency: 'UYU' }).format(Number(earlySettlementResult.grossSelectedAmount) / 100)
                                                : '$0,00'}
                                        </span>
                                    </div>
                                    <div className="advance-summary-table__notcol">
                                        <span className="advance-summary-table__header">
                                            Cupones para llegar al bruto
                                        </span>
                                        <div className='advance-seeCupons'>
                                            {isCalculatingEarlySettlement ? (
                                                <span className="advance-summary-table__value advance-summary-table__value--inline-loading" aria-live="polite">
                                                    <span className="advance-inline-spinner" aria-hidden="true"></span>
                                                    <span className="advance-inline-loading-text">Calculando</span>
                                                </span>
                                            ) : (
                                                <span className="advance-summary-table__value">{earlySettlementResult ? earlySettlementResult.selectedCoupons.length : 0}</span>
                                            )}
                                            <button
                                                className="advance-summary-table__ver-todos"
                                                onClick={() => setShowCouponsSidebar(true)}
                                                disabled={isCalculatingEarlySettlement || sidebarSelectedCoupons.length === 0}
                                            >
                                                        <span>Ver todos</span>
                                                        <span className="advance-summary-table__ver-todos-arrow" aria-hidden="true">&gt;</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {showCouponsSidebar && (
                                <>
                                    <div className="advance-sidebar-overlay" onClick={() => setShowCouponsSidebar(false)} />
                                    <div className="advance-sidebar--coupons">
                                        <div className="advance-sidebar__header">
                                            <span className="advance-sidebar__title">Cupones a anticipar</span>
                                            <button className="advance-sidebar__close" onClick={() => setShowCouponsSidebar(false)} aria-label="Cerrar">&times;</button>
                                        </div>
                                        <div className="advance-sidebar__body">
                                            {earlySettlementResult && earlySettlementResult.selectedCoupons.length > 0 ? (
                                                <div className="advance-sidebar-coupons-layout">
                                                    <div className="advance-sidebar-coupons-card">
                                                        <table className="advance-sidebar-coupons-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Fecha de pago original</th>
                                                                    <th>Cantidad de cupones</th>
                                                                    <th>Monto neto de arancel</th>
                                                                    <th>Costo de anticipacion</th>
                                                                    <th>Monto neto a acreditar</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {sidebarSelectedCoupons.map((coupon, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{coupon.paymentDate}</td>
                                                                        <td>{String(coupon.couponsQuantity).replace(/^0+/, '')}</td>
                                                                        <td>{formatUyuFromCents(Number(coupon.netAmount))}</td>
                                                                        <td>{formatUyuFromCents(Number(coupon.previousCost))}</td>
                                                                        <td>{formatUyuFromCents(Number(coupon.acreditedAmount))}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="advance-sidebar-coupons-totals">
                                                        <div className="advance-sidebar-coupons-total-card advance-sidebar-coupons-total-card--left">
                                                            <p className="advance-sidebar-coupons-total-card__title">Total de cupones</p>
                                                            <p className="advance-sidebar-coupons-total-card__value">{totalSidebarCoupons}</p>
                                                        </div>
                                                        <div className="advance-sidebar-coupons-total-card advance-sidebar-coupons-total-card--right">
                                                            <p className="advance-sidebar-coupons-total-card__title">Neto acumulado</p>
                                                            <p className="advance-sidebar-coupons-total-card__value">{formatUyuFromCents(totalSidebarNetAmount)}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <p className="advance-sidebar-coupons-empty">No hay cupones seleccionados.</p>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="advance-anticipar-btn-wrapper">
                                <SubmitButton
                                    className="advance-anticipar-btn"
                                    disabled={!hasAvailableAmount || amountToAdvance === '' || Number(amountToAdvance) === 0 || isAmountExceeded || isLoadingEarlySettlement || isCalculatingEarlySettlement || !earlySettlementResult || earlySettlementResult.selectedCoupons.length === 0}
                                    onClick={handleEarlySettlement}
                                >
                                    {isLoadingEarlySettlement ? <span className="advance-button-spinner" aria-hidden="true"></span> : <span>Anticipar ahora</span>}
                                </SubmitButton>
                            </div>
                        </div>
                    </div>
                </>
        );
    }

    /////////////////////////////////////////////////////Render anticipo por cupones/////////////////////////////////////////////////////

    const renderSearchCoupons = (): ReactElement => {
        const hasAvailableAmount = Number(totalAmount || 0) > 0;

        const couponsSearchRequest = () => {
            const tranWebModel: IcouponsSearchRequest = {
                fromDate: formatDateForWs81(filters.dateRange?.[0]),
                toDate: formatDateForWs81(filters.dateRange?.[1]),
                maxAmount: filters.amount || "",
                temporalStorageId: "",
                temporalStorageLastItem: "",
                brandsList: getBrandNamesRequest(),
                paymentEntityList: getPaymentEntityListRequest(),
                emitterEntityList: getEmitterEntityList(),
                commerceFiscalNumbersList: getcommerceFiscalNumbersListRequest(),
                Skip: 0,
                Take: 0,
            };
            return tranWebModel;
        }

        const getPaymentEntityListRequest = (): Array<string | undefined> => {
            return paymentEntityList.map(x => x.value).filter(x => x.length > 0);
        }

        const getEmitterEntityList = (): Array<string | undefined> => {
            return paymentEmiterList.map(x => x.value).filter(x => x.length > 0);
        }

        const getBrandNamesRequest = (): Array<string | undefined> => {
            if (filters.brandsCode && filters.brandsCode.length > 0) {
                return [filters.brandsCode];
            }
            return allBrands.filter(x => x.value !== '').map(x => x.value);
        }
        const getcommerceFiscalNumbersListRequest = (): Array<CommerceFiscalNumbersList> => {
            const fiscalNumbers = WebCache.getAllMerchantDocuments(false, false).map(x => x.key);
            let res: Array<CommerceFiscalNumbersList> = [];

            for (const fn of fiscalNumbers) {
                res = res.concat(comercios.filter(x => x.value != "").map(y => {
                    return {
                        fiscalNumber: fn + "",
                        commerceNumber: y.label + ""
                    }
                }));
            }

            if (res.length > 0) {
                return res;
            }

            return allComercios.filter(x => x.value != "").map(y => {
                return {
                    fiscalNumber: extractFiscalNumber(y.value),
                    commerceNumber: y.label + ""
                }
            });
        }

        //Llamamos  al servicio que va a traer los cupones (serviceWS81)
        const getCoupons = async () => {
            try {
                const res: AxiosResponse<IcouponsSearchResponse> = await AdvancedService.couponsSearch(couponsSearchRequest());
                if (res.data) {
                    setSelectedRows([]);
                    allPaymentListsRef.current = res.data.paymentListsDates || [];
                    setMainPage(0);
                    setPaymentLists(allPaymentListsRef.current.slice(0, PAGE_SIZE * PAGE_QUANTITY + 1));
                }
            } catch (error) {
                console.error("Error al buscar cupones", error);
                toast.error("Error al buscar cupones");
            }
        };

        const handleRowSelect = (rowObject: IWS81PaymentLists) => {
            setSelectedRows((prev) => {
                if (prev.includes(rowObject)) {
                    return prev.filter((obj) => obj !== rowObject)
                } else {
                    return [...prev, rowObject]
                }
            });
        };

        const handleSelectAll = () => {
            if (selectedRows.length === allPaymentListsRef.current.length) {
                setSelectedRows([]);
            } else {
                setSelectedRows([...allPaymentListsRef.current])
            }
        }

        const disabledConfirm = (): boolean => {
            let rowsConfirm = (selectedRows.length === 0);
            return rowsConfirm;
        };

        const advancedColumns: ColumnDefinition[] = [
            actionColumnDefinition({
                key: "", label: t(`${T_PREFIX}advancedColumns.selected`), action: {
                    function: (rowObject: IWS81PaymentLists) => {
                        return null
                    },
                    icon: (rowObject: IWS81PaymentLists) => {
                        const isChecked = selectedRows.includes(rowObject)
                        return <div className='containerIconRefund'>
                            <input type="checkbox" checked={isChecked} onChange={() => handleRowSelect(rowObject)} />
                        </div>
                    }
                }
            }),
            textColumnDefinition({ key: 'paymentDate', label: t(`${T_PREFIX}advancedColumns.operationDate`) }),
            textColumnDefinition({
                key: 'brand', label: t(`${T_PREFIX}advancedColumns.brand`), mapValue: (rowObjects: IWS81PaymentLists) => {
                    const brandCode = rowObjects.brand;
                    if (!brandCode) return <></>;
                    const brandName = t(`${T_PREFIX}brand-${brandCode}`);
                    return <img src={UtilService.getImageTag(brandName.toUpperCase())} alt={brandName} title={brandName} className="br-7 transaction-imageAdvanced" />;
                }
            }),
            numericColumnDefinition({
                key: 'couponsQuantity', label: t(`${T_PREFIX}advancedColumns.totalCupons`), mapValue: (indiceCupones: IWS81PaymentLists) => {
                    const qCoupons = indiceCupones.couponsQuantity
                    return qCoupons.replace(/^0+/, '')
                }
            }),
            textColumnDefinition({
                key: 'netAmount', label: t(`${T_PREFIX}advancedColumns.netAmount`), mapValue: (rowObjects: IWS81PaymentLists) => {
                    const netAmount = rowObjects.netAmount
                    return Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(netAmount) / 100)
                }
            }),
            textColumnDefinition({
                key: 'previousCost', label: t(`${T_PREFIX}advancedColumns.anticipationCostAmount`), mapValue: (rowObjects: IWS81PaymentLists) => {
                    const previousCost = rowObjects.previousCost
                    return Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(previousCost) / 100)
                }
            }),
            textColumnDefinition({
                key: 'acreditedAmount', label: t(`${T_PREFIX}advancedColumns.anticipationAmount`), mapValue: (rowObjects: IWS81PaymentLists) => {
                    const acreditedAmount = rowObjects.acreditedAmount
                    return Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(acreditedAmount) / 100)
                }
            }),
        ];

        return (
            <>
                <div className="advance-by-amount-outer">
                    <div className="advance-by-amount-inner advance-coupons-content">
                        <div className="advance-amount-input-title">Cupones disponibles para anticipar</div>
                        <FormFilter model={[filters, setFilters]} clear={clearFilters} onSubmit={getCoupons} hidden={UtilService.isMobilePlatform() ? true : false}
                        >
                            <>
                                <div className="row form-filter">
                                    <div className="col-md-4">
                                        <DateField attr="dateRange" label="dateRange" range></DateField>
                                    </div>
                                    <div className="col-md-4">
                                        <NumericField attr='amount' label={`${T_PREFIX}formFilter.amount`} ></NumericField>
                                    </div>
                                    <div className="col-md-4">
                                        <SelectField attr='brandsCode' label={`${T_PREFIX}formFilter.brandsCode`} options={allBrands}></SelectField>
                                    </div>
                                </div>
                            </>
                        </FormFilter>
                        <nav className="nav mb-4 advance-coupons-actions">
                            {paymentLists.length > 0 ? (
                                <><span className="vertical-align border-0 mt-0 advance-coupons-actions__select-all">
                                    <input
                                        type='checkbox'
                                        onChange={handleSelectAll}
                                        checked={allPaymentListsRef.current.length > 0 && selectedRows.length === allPaymentListsRef.current.length} />
                                    <span>{t(`${T_PREFIX}selectAll`)}</span>
                                </span><div className="advance-anticipar-btn-wrapper">
                                        <SubmitButton className="advance-anticipar-btn" onClick={() => setShowConfirmationSidebar(true)} disabled={disabledConfirm() || !hasAvailableAmount}>
                                            <span>Anticipar ahora</span>
                                        </SubmitButton>
                                    </div></>
                            ) : <span></span>}
                        </nav>
                        <div className="row">
                            <div className="col-md-12">
                                <CustomTable
                                    columnDefinitions={advancedColumns}
                                    rowObjects={paymentLists}
                                    config={{
                                        mode: TableModeEnum.LIST,
                                        pageSize: PAGE_SIZE,
                                        paginator: {
                                            quantity: PAGE_QUANTITY,
                                            mainPage: mainPage,
                                            modifyMainPage: (value: number, newPages: Array<number>) => {
                                                const newMainPage = mainPage + value;
                                                setMainPage(newMainPage);
                                                const start = newMainPage * PAGE_SIZE * PAGE_QUANTITY;
                                                setPaymentLists(allPaymentListsRef.current.slice(start, start + PAGE_SIZE * PAGE_QUANTITY + 1));
                                            },
                                            pageRequest: {
                                                Skip: 0,
                                                Take: 0
                                            }
                                        }
                                    }}
                                ></CustomTable>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-12 d-flex justify-content-center">
                                <div className="advance-summary-table">
                                    <div className='advance-summary-table__subtable'>
                                        <div className="advance-summary-table__col">
                                            <span className="advance-summary-table__header">Neto solicitado</span>
                                            <span className="advance-summary-table__value">
                                                ${Intl.NumberFormat('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(sumaryTotals.totalAcreditedAmount) / 100)}
                                            </span>
                                        </div>
                                        <div className="advance-summary-table__col">
                                            <span className="advance-summary-table__header">
                                                Bruto necesario
                                                <span className="advance-summary-table__tooltip" title="El importe puede resultar superior al necesario ya que se calcula del monto total de cada venta en condiciones de Anticipar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                                </span>
                                            </span>
                                            <span className="advance-summary-table__value">
                                                ${Intl.NumberFormat('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(sumaryTotals.totalNetAmount) / 100)}
                                            </span>
                                        </div>
                                        <div className="advance-summary-table__notcol">
                                            <span className="advance-summary-table__header">
                                                Cupones para llegar al bruto
                                            </span>
                                            <div className='advance-seeCupons'>
                                                <span className="advance-summary-table__value">{sumaryTotals.totalCouponsQuantity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>          
                </div>
            </>
        );
    };

    ////////////////////////////////////////////////////////////////////////////////Render confirmacion/////////////////////////////////////////////////////////////////////////////////////////
    const renderConfirmation = (): ReactElement => {

        const getLiquidationsConfirmationRequest = () => {
            const tranWebModel: IliquidationsConfirmationRequest = {
                user: '',
                temporalStorageId: '',
                itemNumber: '',
                moreData: 'N',
                datesLists: selectedRows.map(payment => ({
                    fiscalNumber: payment.fiscalNumber,
                    commerceNumber: payment.commerceNumber,
                    brand: payment.brand,
                    currencyCode: payment.currencyName,
                    countryCode: payment.countryCode,
                    paymentEntity: payment.paymentEntity,
                    emiterEntity: payment.emmiterEntity,
                    paymentDate: payment.paymentDate,
                    operationType: payment.operationType,
                    agreementRateCode: payment.agreementRateCode,
                    agreementRate: payment.agreementRate,
                    investorCode: payment.investmentEntity
                }))
            };
            return tranWebModel;
        }

        const isMontoTab = activeTab === 'porMonto';

        //Llamamos al servicio de confirmacion de adelanto (serviceWS82)
        const confirmAdvanced = async () => {
            if (isConfirmingAdvanced) {
                return;
            }

            setIsConfirmingAdvanced(true);
            try {
                const montoDatesList = (earlySettlementResult?.selectedCoupons ?? []).map(payment => ({
                    fiscalNumber: payment.fiscalNumber,
                    commerceNumber: payment.commerceNumber,
                    brand: payment.brand,
                    currencyCode: payment.currencyName,
                    countryCode: payment.countryCode,
                    paymentEntity: payment.paymentEntity,
                    emiterEntity: payment.emmiterEntity,
                    paymentDate: payment.paymentDate,
                    operationType: payment.operationType,
                    agreementRateCode: payment.agreementRateCode,
                    agreementRate: payment.agreementRate,
                    investorCode: payment.investmentEntity
                }));
                const confirmationRequest: IliquidationsConfirmationRequest = isMontoTab
                    ? {
                        user: '',
                        temporalStorageId: '',
                        itemNumber: '',
                        moreData: 'N',
                        datesLists: montoDatesList
                    }
                    : getLiquidationsConfirmationRequest();

                const res: AxiosResponse<IliquidationsConfirmationResponse> = await AdvancedService.liquidationsConfirmation(confirmationRequest);
                if (res.data.returnCode === "00000") {
                    console.log(res.data);
                    setShowConfirmationSidebar(false);
                    setSuccessMode(isMontoTab ? 'monto' : 'cupones');
                    setShowSuccessSidebar(true);
                    setSelectedRows([]);
                    if (isMontoTab) {
                        setAmountToAdvance('');
                    }
                } else {
                    toast.error("Error al generar el anticipo");
                }
            } catch (error) {
                console.error("Error al generar el anticipo:", error);
                toast.error("Error al generar el anticipo");
            } finally {
                setIsConfirmingAdvanced(false);
            }
        };

        //Mapeo para mostrar agrupado los datos en el resumen de anticipos
        const montoSelectedCoupons = earlySettlementResult?.selectedCoupons ?? [];
        const netAmountGroup = isMontoTab
            ? Number(earlySettlementResult?.selectedAmount ?? 0) / 100
            : selectedRows.reduce((acc, item) => acc + (Number(item.acreditedAmount) / 100), 0);
        const previousCostGroup = isMontoTab
            ? (Number(earlySettlementResult?.grossSelectedAmount ?? 0) - Number(earlySettlementResult?.selectedAmount ?? 0)) / 100
            : selectedRows.reduce((acc, item) => acc + (Number(item.previousCost) / 100), 0);
        const netAcreditedAmountGroup = isMontoTab
            ? Number(earlySettlementResult?.grossSelectedAmount ?? 0) / 100
            : selectedRows.reduce((acc, item) => acc + (Number(item.netAmount) / 100), 0);
        const tnaApplicable = isMontoTab
            ? (() => {
                const rawTna = Number(earlySettlementResult?.averageTna ?? 0);
                if (!Number.isFinite(rawTna) || rawTna <= 0) {
                    return '-';
                }

                const normalizedTna = rawTna / 1000;
                return formatTnaPercent(normalizedTna);
            })()
            : (() => {
                const rates = Array.from(new Set(selectedRows.map(item => item.agreementRate).filter(r => r && r.trim().length > 0)))
                    .map(r => Number(r.replace(',', '.')) / 1000).filter(r => !Number.isNaN(r));
                if (rates.length === 0) {
                    return '-';
                }

                if (rates.length === 1) {
                    return formatTnaPercent(rates[0]);
                }

                return `${formatTnaPercent(Math.min(...rates))} - ${formatTnaPercent(Math.max(...rates))}`;
            })();

        /* Lógica para deshabilitar el continuar si no se aceptan los terminos.*/
        const isSubmitDisabled = (): boolean => {
            let isTermsNotAccepted = !(termsAccepted);
            return isTermsNotAccepted;
        };

        const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            setTermsAccepted(event.target.checked);
        };

        return (
            <>
                <div className={`advance-confirmation-content${isConfirmingAdvanced ? ' advance-confirmation-content--loading' : ''}`}>
                    <div className='advance-confirmation-summary-card'>
                        <div className='advance-confirmation-accredit-box'>
                            <p className='advance-confirmation-accredit-label'>Monto a acreditar</p>
                            <span className='advance-confirmation-accredit-value'>
                                {Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(netAmountGroup))}
                            </span>
                        </div>
                        <div className='advance-confirmation-details'>
                            <div className='advance-confirmation-details__row advance-confirmation-details__row--highlight'>
                                <div className='advance-confirmation-details__row-content'>
                                    <p>Monto anticipado aproximado</p>
                                    <span className='advance-confirmation-details__value-with-tooltip'>
                                        <span>{Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(netAmountGroup))}</span>
                                        <span className='advance-confirmation-details__tooltip' title="Importe sin descuento de Arancel e impuestos" aria-label="Importe sin descuento de Arancel e impuestos">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className='advance-confirmation-details__row'>
                                <div className='advance-confirmation-details__row-content'>
                                    <p>Bruto necesario</p>
                                    <span>{Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(netAcreditedAmountGroup))}</span>
                                </div>
                            </div>
                            {isMontoTab && (
                                <div className='advance-confirmation-details__row'>
                                    <div className='advance-confirmation-details__row-content'>
                                        <p>Cupones seleccionados</p>
                                        <span>{earlySettlementResult?.selectedCoupons?.length ?? 0}</span>
                                    </div>
                                </div>
                            )}
                            <div className='advance-confirmation-details__row'>
                                <div className='advance-confirmation-details__row-content'>
                                    <p>Costo de anticipo estimado</p>
                                    <span>{Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(previousCostGroup))}</span>
                                </div>
                            </div>
                            <div className='advance-confirmation-details__row'>
                                <div className='advance-confirmation-details__row-content'>
                                    <p>TNA Aplicable</p>
                                    <span>{tnaApplicable}</span>
                                </div>
                            </div>
                            <div className='advance-confirmation-details__row'>
                                <div className='advance-confirmation-details__row-content'>
                                    <p>Plazo de acreditacion</p>
                                    <span>24 hs habiles</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='advance-confirmation-terms mt-4'>
                        <input type="checkbox" name="terms" onChange={handleTermsChange} />
                        <label>
                            Los presentes {' '}<Link onClick={openTermsAndConditionsModal} className="linkTo" to={''}> términos y condiciones</Link> corresponden al Capítulo IV: Formas de venta que forma parte del {' '}<Link onClick={openRegulationCommerceModal} className="linkTo" to={''}> Reglamento de Comerciantes</Link>
                        </label>
                    </div>
                </div>
                <button className="advance-confirmation-submit" onClick={() => confirmAdvanced()} disabled={isSubmitDisabled() || isConfirmingAdvanced}>
                    <div className='submit-button-container'>
                        {isConfirmingAdvanced ? (
                            <span className="advance-button-spinner" aria-hidden="true"></span>
                        ) : (
                            <span className='advance-confirmation-submit-text'>Anticipar</span>
                        )}
                    </div>
                </button>
                {isConfirmingAdvanced && (
                    <div className="advance-confirmation-loading-overlay" aria-live="polite" aria-busy="true"></div>
                )}
                <Modal show={showTermsAndConditionsModal} dialogClassName="footer-modal">
                    <div className="modal-content modal-content-demo">
                        <div className="modal-body">
                            <div className="scrollable-container">
                                <TermsAndContions country={country} />
                            </div>
                        </div>
                        <div className="footerModal">
                            <SubmitButton label={t(`close`)} className="me-3" onClick={() => closeTermsAndConditionsModal()} noBlock></SubmitButton>
                        </div>
                    </div>
                </Modal>
                <Modal show={showRegulationCommerce} dialogClassName="footer-modal">
                    <div className="modal-content modal-content-demo">
                        <div className="modal-body">
                            <div className="scrollable-container">
                                <RegulationCommerce />
                            </div>
                        </div>
                        <div className="footerModal">
                            <SubmitButton label={t(`close`)} className="me-3" onClick={() => closeRegulationCommerceModal()} noBlock></SubmitButton>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }

    return (
        <Page >
            <>
                <div className="mb-4">
                    {!WebCache.isPosnetAppUser() && <h2>{t('paymentSchedule')}</h2>}
                    {!WebCache.isPosnetAppUser() && <h4>{t('conciliationCalendar')}</h4>}
                    <NavigationTabLinksForCalendar></NavigationTabLinksForCalendar>
                </div>
                <div className="advanced-refund-container">
                    <div className="navTab-advanced">
                        <div className="navTab-advanced__tabs">
                            <button
                                className={`navTab-advanced__tab${activeTab === 'porMonto' ? ' navTab-advanced__tab--active' : ''}`}
                                onClick={() => setActiveTab('porMonto')}
                            >
                                Por monto
                            </button>
                            <button
                                className={`navTab-advanced__tab${activeTab === 'porCupones' ? ' navTab-advanced__tab--active' : ''}`}
                                onClick={() => setActiveTab('porCupones')}
                            >
                                Por cupones
                            </button>
                        </div>
                        {activeTab === 'porMonto' && totalCoupon()}
                        {activeTab === 'porCupones' && renderSearchCoupons()}
                    </div>
                </div>
                {showConfirmationSidebar && (
                    <>
                        <div className="advance-sidebar-overlay" onClick={() => { if (!isConfirmingAdvanced) { setShowConfirmationSidebar(false); } }} />
                        <div className="advance-sidebar advance-sidebar--wide">
                            <div className="advance-sidebar__header">
                                <span>Resumen de anticipo</span>
                                <button className="advance-sidebar__close" onClick={() => setShowConfirmationSidebar(false)} aria-label="Cerrar" disabled={isConfirmingAdvanced}>&times;</button>
                            </div>
                            {renderConfirmation()}
                        </div>
                    </>
                )}
                {showSuccessSidebar && (
                    <>
                        <div className="advance-sidebar-overlay" />
                        <div className="advance-sidebar advance-sidebar--wide">
                            <div className="advance-sidebar__header">
                                <span>{successMode === 'monto' ? 'Anticipo por monto' : 'Anticipo por cupones'}</span>
                            </div>
                            <div className="advance-sidebar__body advance-success-content">
                                <LogoSVG />
                                <p className='advance-success-title mt-4'>¡La solicitud de anticipo fue enviada con éxito!</p>
                                <p className='advance-success-subtitle mt-4'>En 24 hrs hábiles tendrás el dinero disponible en tu cuenta</p>
                                <button className="advance-confirmation-submit advance-confirmation-submit--fullwidth" onClick={handleBackToSchedule}>
                                    <div className='submit-button-container w-100'>
                                        <span className="advance-confirmation-submit-text w-100">Volver a agenda de pagos</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </>
        </Page>
    )
}
export default withTranslation()(AdvancedRefund);
